const mapBX24AuthToPayload = (auth) => ({
  memberId: auth.member_id,
  domain: auth.domain,
  accessToken: auth.access_token,
  refreshToken: auth.refresh_token,
  expiresIn: auth.expires_in,
});

export default mapBX24AuthToPayload;
